
import { BPMasterModel, BPMasterModelSAP, IBPMasterModel, IBPMasterModelSAP, IBPAddressesModel, IBPAddressesModelSAP, BPAddressesModel, BPAddressesModelSAP } from 'src/app/core/models/masters/bp-master.model';
import { Component, Inject, Input, ɵpublishDefaultGlobalUtils } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
//import { enumBPMaster, enumDataTypes, enumErrorMessageText, enumFormModes, enumObjectType } from '../../../infrastructure/infrastructure-services/common/common-enums';
import { GenericCflViewComponent } from 'src/app/infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { GenericEntryForm } from 'src/app/infrastructure/infrastructure-services/generics/genericentryform/generic-entry-form';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { DataService } from 'src/app/shared/constants/data.service';
import { WrapperStandardFilter } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { GenericAutoCompleteView } from 'src/app/infrastructure/infrastructure-services/generics/generic-autocomplete-view/generic-autocomplete-view';
import { FormControl } from '@angular/forms';
import { map, Observable, startWith } from 'rxjs';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { SharedModule } from 'src/app/shared/shared.module';

interface Country {
  name: string;
  code: string;
}

@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.component.html',
  styleUrls: ['./add-address.component.css']

})
export class AddAddressComponent extends GenericEntryForm<IBPMasterModel, IBPMasterModelSAP> {

  addres: any
  gstType: any
  address_data: any;
  index = 0
  country: any;
  countryCode: any;
  filterItem: any[] = [];
  genAutoComplete = new GenericAutoCompleteView<IBPMasterModel>(this.agenericRepositoryForCfl, this.routerForCfl);
  address_data1: any;
  type: any;
  isBoolCopyToShipToAddressChecked: boolean = false;
  //@Input() addressData: any;

  constructor(agenericRepository: GenericService<IBPMasterModel>,
    public agenericRepositoryForCfl: GenericService<IBPMasterModel>,
    public matDialogRefForCfl: MatDialogRef<GenericCflViewComponent<IBPMasterModel>>,
    public routerForCfl: Router, public dialogRef: MatDialogRef<AddAddressComponent>,
    public dataService: DataService,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public matDialogforCfl: MatDialog, router: Router, dialog: MatDialog, private dbService: NgxIndexedDBService) {

    super(agenericRepository, router, dialog)
    this.address_data1 = { ...data };
    this.address_data = this.address_data1.editedAddress;

    // this.gstType=this.address_data1;
    // console.log(this.address_data1)



    // this.id=id;

    // let address = new BPMasterModel();
    // let addressSAP = new BPMasterModelSAP();
    // this.setEntryFormDataSource = address;
    // this.setEntryFormDataSourceSAP = addressSAP;

    // let BPAddress = new BPAddressesModel();
    // address.bpAddresses.push(BPAddress);
    //address.bpAddresses.push(this.address_data);    
  }
  myControl = new FormControl<string | Country>('');
  options: Country[] = []
  filteredOptions!: Observable<Country[]>;
  //  address.bpAddresses.push(this.address_data);

  ngOnInit() {
    //console.log(this.address_data1.enumData);

    this.getIntialAPIListForCountry();
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.options.slice();
      }),
    );
  }

  async getIntialAPIListForCountry() {
    this.genAutoComplete.setACDataSourceURL = 'Country/GetCountryListService';
    this.genAutoComplete.setACSortColumn = "name";
    let result = await this.genAutoComplete.onClickOptionsList();
    result.forEach((element: any) => {
      this.options.push({ 'name': element.name, 'code': element.code });
    });
  }

  // displayFn(user: Country): string {
  //   // return user && user.name ? user.name : '';
  //   return JSON.stringify(user.name);
  // }

  private _filter(name: string): Country[] {
    const filterValue = name.toLowerCase();
    // console.log('name' + name);
    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  OnOptionSelected(option: Country) {
    this.country = option;
    this.countryCode = option ? option.code : null;
    this.address_data.country = this.countryCode;
  }

  selectedData: any;
  onOpenDropDown(value: any) {
    let genCFL = new GenericCflViewComponent<IBPMasterModel>(this.agenericRepositoryForCfl, this.routerForCfl, this.matDialogforCfl, this.matDialogRefForCfl, this.data, this.dbService);
    let filter: WrapperStandardFilter = new WrapperStandardFilter();
    if (value == 'country') {
      genCFL.setCflTitle = "Country";
      genCFL.setCflViewDataSourceURL = 'Country/GetCountryListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.address_data.countryName;
      genCFL.setSortColumn = "name";
    }

    if (value == 'state') {
      genCFL.setCflTitle = "State";
      genCFL.setCflViewDataSourceURL = 'State/GetStateListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.address_data.stateName;
      genCFL.setSortColumn = "name";
      filter.Key = 'country';
      filter.OperatorType = "contains";
      filter.Value = this.address_data.country;
      genCFL.setCflFilterArray = filter;

    }
    if (value == 'gsttype') {
      genCFL.setCflTitle = "GST Type";
      genCFL.setIsItCflEnumList = true;
      genCFL.setCflEnumStoreName = 'BPForm';
      genCFL.setCflEnumDataToStoreInDB = this.address_data1.gstType.enumData;
      genCFL.setCflEnumObjectNameToDisplay = 'gstType';
      genCFL.setCflDisplayedColumnsNamesList = ['description'];
      genCFL.setSortColumn = "value";
      genCFL.setCflSelectedData = this.address_data1.gstTypeName;
    }


    genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
      if (res != undefined && res.event != undefined) {
        if (this.btnText == 'Language.OkText') {
          this.btnText = 'Language.UpdateText';
        }
        this.selectedData = res.event;
        if (value == 'country') {
          //this.selectedData = res.event.code;
          this.address_data.country = res.event.code;
          this.address_data.countryName = res.event.name;
        }
        if (value == 'state') {
          //this.selectedData = res.event.code;
          this.address_data.state = res.event.code;
          this.address_data.stateName = res.event.name;
        }
        if (value == 'gsttype') {
          this.address_data.gstType = res.event.value;
          this.address_data.gstTypeName = res.event.description;
        }


      }
    })

  }

  //  onSave() {
  //     this.dialogRef.close({ event: true, value:JSON.stringify(this.dataSource)
  //       ,startDate:this.startDate,endDate:this.endDate});
  //   }

  onSave() {
    this.dialogRef.close(this.address_data);

  }
  onCancel() {
    this.dialogRef.close(false);
  }

  // onEditAddress(item: any, i: number) {
  //   this.indexAddress = i;
  // }



  onChangeCopyCheckBox(val: any) {
    if (val.checked) {
      this.address_data.isBoolCopyToShipToAddressChecked = true;//"tYES";
      let Address = new BPAddressesModel();
      Address.addressType = 'bo_ShipTo';
      Address.addressName = this.address_data.addressName;
      Address.country = this.address_data.country;
      Address.countryName = this.address_data.countryName;
      Address.street = this.address_data.street;
      Address.streetNo = this.address_data.streetNo;
      Address.city = this.address_data.city;
      Address.state = this.address_data.state;
      Address.stateName = this.address_data.stateName;
      Address.zipCode = this.address_data.zipCode;
      Address.gstType = this.address_data.gstType;
      Address.gstTypeName = this.address_data.gstTypeName;
      Address.gstin = this.address_data.gstin;
      Address.isAsDefault = this.address_data.isDefaultAddress;
      this.address_data.push(this.address_data);
    } else {
      this.address_data.isBoolCopyToShipToAddressChecked = false;//"tNO";
      //this.getEntryFormDataSource.bpAddresses.splice(this.indexAddress+1,1);
    }
  }
}
